module.exports = __webpack_public_path__ + "media/src/images/change-password-128-19c4531b47fad919044ae32024f3a2f6.png";